export default "__VITE_ASSET__30f07faa__"